import store from './store.js'
import router from '@/router'
class Publics{
  //判断是否需要登录
  mustlogin(){
    const  token_type =store.state.token_type
    const  access_token = store.state.token
    if((token_type==null || access_token==null || token_type=='' || access_token=='')){
        router.push({path:'/login'})
        console.log('login')
        return true
    }
    return false
  }
}

var Nodes = new Publics();
export default Nodes;



// WEBPACK FOOTER //
// ./src/utils/nodes.js